export default function Step5() {
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.713 11.0166C28.8337 11.0166 24.9157 7.22931 24.8838 7.19722L24 6.29395L23.1071 7.19722C23.0706 7.23848 19.2346 11.0166 10.2825 11.0166C9.94533 11.0166 9.59909 11.012 9.24829 10.9983L8 10.957L8 26.0718C8 30.5652 9.61276 37.1219 23.5626 42.138L24 42.2939L24.4374 42.138C38.3872 37.1219 40 30.5652 40 26.0718V10.957L38.7472 10.9983C38.3964 11.012 38.0501 11.0166 37.713 11.0166Z"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M16 24.5797L21 30.2939L32 18.2939" stroke="#010101" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
